"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapSearchResultsPageQueryToRelatedQueries = void 0;
var _mapLinksToSearchQueries = require("./mapLinksToSearchQueries");
const mapSearchResultsPageQueryToRelatedQueries = (data)=>{
    var _data_application_productSearchPage, _data_application;
    if (!((_data_application = data.application) === null || _data_application === void 0 ? void 0 : (_data_application_productSearchPage = _data_application.productSearchPage) === null || _data_application_productSearchPage === void 0 ? void 0 : _data_application_productSearchPage.products)) {
        return undefined;
    }
    const { products } = data.application.productSearchPage;
    return {
        searchedTerm: products.searchedTerm,
        brands: (0, _mapLinksToSearchQueries.mapLinksToSearchQueries)(products.relatedBrandLinks),
        categories: (0, _mapLinksToSearchQueries.mapLinksToSearchQueries)(products.relatedCategoryLinks)
    };
};
exports.mapSearchResultsPageQueryToRelatedQueries = mapSearchResultsPageQueryToRelatedQueries;
